import { render, staticRenderFns } from "./PptMain.vue?vue&type=template&id=5154f532&"
import script from "./PptMain.vue?vue&type=script&lang=js&"
export * from "./PptMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptMain.vue"
export default component.exports